import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { refsStore } from '../managers/globalState';
import { formatDate, formatTime } from '../helpers/tools';

const DateTimeDisplay = ({ inline = false, updateInterval = 100 }) => {
	const [formattedDate, setFormattedDate] = useState(null);
	const [formattedTime, setFormattedTime] = useState(null);

	useEffect(() => {
		const updateDatetime = () => {
			// Get the current datetime from
			const { get } = refsStore.stateSnapshot;
			const localDate = get('time').getDatetime();

			// Set the formatted date and time.
			setFormattedDate(formatDate(localDate));
			setFormattedTime(formatTime(localDate));
		};

		const interval = setInterval(updateDatetime, updateInterval);

		return () => {
			clearInterval(interval);
		};
	}, [updateInterval]);

	const className = 'date-time-display outline';

	return (
		<>
			{formattedDate ? <div className={className}>{formattedDate}</div> : null}
			{formattedTime ? <div className={`${className} ${inline ? 'inline' : ''}`}>{formattedTime}</div> : null}
		</>
	);
};

DateTimeDisplay.propTypes = {
	inline: PropTypes.bool,
	updateInterval: PropTypes.number
};

export default DateTimeDisplay;
